import '../styles/Login.css';

import React, { useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { useAuth } from '../contexts/AuthContext';
import {
  Button,
  Card,
  Container,
  Input,
  Typography,
} from './common';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, resetPassword } = useAuth();
  const navigate = useNavigate();

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();

    try {
      setError('');
      setLoading(true);
      await login(email, password);
      navigate('/dashboard');
    } catch (error) {
      setError('Failed to sign in');
      console.error(error);
    }

    setLoading(false);
  }

  async function handleForgotPassword() {
    if (!email) {
      setError('Please enter your email address');
      return;
    }

    try {
      setMessage('');
      setError('');
      setLoading(true);
      await resetPassword(email);
      setMessage('Check your inbox for password reset instructions');
    } catch (error) {
      setError('Failed to reset password');
      console.error(error);
    }

    setLoading(false);
  }

  return (
    <Container>
      <Card>
        <Typography variant="h2" align="center">Login to Coach App</Typography>
        
        {error && (
          <div className="error-message">
            {error}
          </div>
        )}
        
        {message && (
          <div className="success-message">
            {message}
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <Input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            label="Email"
            required
          />
          
          <Input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            label="Password"
            required
          />
          
          <Button 
            type="submit"
            disabled={loading}
            fullWidth
          >
            {'Login'}
          </Button>

          <div className="forgot-password">
            <Button
              variant="secondary"
              onClick={handleForgotPassword}
              disabled={loading}
            >
              Forgot Password?
            </Button>
          </div>
        </form>
      </Card>
    </Container>
  );
}